module.exports = __webpack_public_path__ + "static/img/IMG_20150523_194400.c3d10269.jpg";